// Copyright (c) 2025 Siemens

/**
 * @module js/DesCatalogConsentPageService
 */

export const validateTnCCheckoxValue = (value) => {
    // This is useful to invoke any API for checking of terms and conditons or status
    return {
        checked: value === true || value === 'true' ? true : false
    };
}
